export function initBarGlobal(chartData) {
  google.charts.load("current", { packages: ["bar"] });
  google.charts.setOnLoadCallback(drawChart);

  function drawChart() {
    const data = google.visualization.arrayToDataTable([
      ["Months", "Amount", "Quantity"],
      ...chartData // Inserta los datos desde Ruby como array JS
    ]);

    const options = {
      width: "100%",
      height: 450,
      chart: {
        title: "Global Quotes",
        subtitle: "Amount on the left, Quantity on the right"
      },
      bars: "vertical",
      series: {
        0: { axis: "amount" },
        1: { axis: "quantity" }
      }
    };

    const chart = new google.charts.Bar(document.getElementById("bar-chart-global"));
    chart.draw(data, options);
  }

  window.addEventListener("resize", () => {
    setTimeout(drawChart, 500);
  });
}

$(document).ready(() => {
  $('#from_chart').datetimepicker({
    minDate: moment("04/01/2019"),
    format: "MM-YYYY",
    useCurrent: true,
    defaultDate: moment(`${moment().year()}-${moment().month() + 1}`, "YYYY-M")
  });

  $("form#searchFormChart #from_chart").keyup(function (e) {
    if ($("form#searchFormChart #from_chart").get(0).value == '') {
      e.preventDefault();
      $("form#searchFormChart").sendRequest();
    }
  });
});
